import {Pagination} from '@mui/material'
import {
  ButtonsHolder,
  PaginationHolder,
  PaginationStats,
} from 'organization/Event/Attendants'
import {useEventInvites} from 'organization/Event/Attendants/EventInvitesProvider'
import {ListInvite} from 'organization/Event/Attendants/ListInvite'
import React, {useState} from 'react'
import {useI18n} from 'i18n/I18nContext'

export const Invited = () => {
  const {t} = useI18n()
  const {invites, totalPages, page, changePage, search, from, to, total} =
    useEventInvites()

  const [timer, setTimer] = useState<any>(null)

  function delayedSearch(change: string) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
    setTimer(
      setTimeout(() => {
        search(change)
      }, 500),
    )
  }

  return (
    <div className="col-xxl-12 mt-5">
      <div className="create__event-area">
        <div className="body__card-wrapper">
          <p>
            <b>{t('orgInvited.title')}</b>
          </p>

          <div className="attendant__wrapper mb-35">
            <ButtonsHolder>
              <div className="singel__input-field mr-15">
                <input
                  type="email"
                  name="email"
                  placeholder={t('orgInvited.searchPh')}
                  onChange={(e) => {
                    delayedSearch(e.target.value)
                  }}
                />
              </div>
            </ButtonsHolder>

            <table>
              <thead>
                <tr>
                  <th>{t('orgInvited.thInviteNo')}</th>
                  <th>{t('orgInvited.thEmail')}</th>
                  <th>{t('orgInvited.thTicket')}</th>
                  <th>{t('orgInvited.thInvitedAt')}</th>
                  <th>{t('orgInvited.thStatus')}</th>
                  <th>{/* ACTIONS */}</th>
                </tr>
              </thead>
              <tbody>
                {invites.length === 0 && (
                  <tr>
                    <td colSpan={6}>{t('orgInvited.empty')}</td>
                  </tr>
                )}
                {invites &&
                  invites.map((invite, index) => (
                    <ListInvite invite={invite} index={index} />
                  ))}
              </tbody>
            </table>

            <PaginationHolder>
              <div></div>
              <Pagination
                count={totalPages}
                shape="rounded"
                page={page}
                onChange={changePage}
              />
              <PaginationStats>
                {t('orgInvited.pageOf')
                  .replace('{from}', String(from))
                  .replace('{to}', String(to))
                  .replace('{total}', String(total))}
              </PaginationStats>
            </PaginationHolder>
          </div>
        </div>
      </div>
    </div>
  )
}
